module.exports = __webpack_public_path__ + "img/GAME.7490633c.svg";